export default "__VITE_ASSET__2cab175d__"